import { render, staticRenderFns } from "./notifications-list.vue?vue&type=template&id=52432947&"
import script from "./notifications-list.vue?vue&type=script&lang=js&"
export * from "./notifications-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports